<template>
	<div class="page_content" aria-label="Explore Intro view content page">

		<div class="row page-heading" v-if="userrole != 'Student'">
			<div class="col-xl-8 col-lg-8 col-md-8 col-sm-11 col-xs-11 input module_heading" role="heading" aria-level="1">
		    	<!--<span class="module_icon icon-institution"></span>-->
		    	<div class="student-menu icon-container" v-if="!isClearlyNextPackageEnabled">
		        	<b-link v-if="isExplorePackageEnabled" class="ic icon-explore" :to="{ name: 'exploreIntro' }" aria-label="Explore" style="float: left;"></b-link>
		    	</div>
		    	<div class="head_txt module_type_name institution-title ace_sec_hd" style="margin-left: 15px;">Explore</div>
		  	</div>
		  	<div class="col-xl-4 col-lg-4 col-md-4 col-sm-1 col-xs-1 btn_container">
		  		<!--
		    	<b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
		      		<template slot="button-content">
		        		<span class="icon-menu3x3"></span>
		      		</template>
		    	</b-dropdown>
		    	<b-btn class="btn btn-primary">Request Info</b-btn>
		    	<b-btn class="btn btn-primary">Apply Now</b-btn>
		    	-->
			</div>
		</div>

		<div class="page_content_container">
      		<div class="row explore_intro">

      			<div class="col-xl-1 col-lg-1 col-md-12 col-sm-12"></div>

      			<div class="col-xl-10 col-lg-10 col-md-12 col-sm-12">
      				<div class="row">

						<div v-if="isExploreProgramsEnabled" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 pkg_entity_bx programs">
						   	<button @click="programGuideResultsClicked" class="ace_sec" aria-label="Explore programs">
								<span class="bx_inner">
									<span class="thumbnail_container">
										<div class="ico-degreeProgram ic"></div>
									</span>
									<span class="entity_title">
										<span class="entity_title_txt">Explore Programs</span>
									</span>
								</span>
							</button>
						</div>

						<div v-if="isExploreCareersEnabled" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 pkg_entity_bx careers">
						  	<button @click="careerResultsClicked" class="ace_sec" aria-label="Explore Careers">
								<span class="bx_inner">
									<span class="thumbnail_container">
										<span class="ico-career ic"></span>
									</span>
									<span class="entity_title">
										<span class="entity_title_txt">Explore Careers</span>
									</span>
								</span>
						   </button>
						</div>

						<div v-if="isExploreInsightsEnabled" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 pkg_entity_bx insight">
						   	<button @click="insightsResultsClicked" class="ace_sec" aria-label="Explore Insights">
								<span class="bx_inner">
									<span class="thumbnail_container">
										<span class="ico-insight ic"></span>
										<!--
										<span class="insight_txt">Do you want to know more about what your Alumni did? Click for Insights.</span>
										-->
									</span>
									<span class="entity_title">
										<span class="entity_title_txt">Explore Insights</span>
									</span>
								</span>
						  	</button>
						</div>

					</div>
				</div>

        	</div>
		</div>

  </div>
</template>

<script>
import '../../../assets/module/sass/explore/explore.scss'
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'

export default {
  name: 'exploreIntro',
  props: ['uuid'],
  components: {
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      libraryList: []
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    ...mapActions([
      'loadAllLibraryForUser',
      'resetProgramGuideSearchState',
      'resetCareerSearchState',
      'loadLogDashboardActivity'
    ]),

    loadData () {
      this.loadAllLibraryForUser().then(learningSpaces => {
        this.libraryList = []
        if (learningSpaces && learningSpaces.length > 0) {
          for (var i = 0; i < learningSpaces.length; i++) {
            const category = learningSpaces[i].category
            if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
              this.libraryList.push(learningSpaces[i].uuid)
            }
          }
        }
      })
    },

    programGuideResultsClicked () {
      this.resetProgramGuideSearchState()
      this.loadLogDashboardActivity({action: 'clickExplorePrograms', page: 'exploreIntro', link: ''})
      return this.$router.push({ name: 'exploreProgramGuideResults' })
    },

    careerResultsClicked () {
      this.resetCareerSearchState()
      this.loadLogDashboardActivity({action: 'clickExploreCareers', page: 'exploreIntro', link: ''})
      return this.$router.push({ name: 'exploreCareerResults' })
    },

    insightsResultsClicked () {
      this.loadLogDashboardActivity({action: 'clickExploreInsights', page: 'exploreIntro', link: ''})
      return this.$router.push({ name: 'exploreInsightsResults' })
    }

  },
  computed: {
    ...mapState({
      'majors': state => state.explore.majors,
      'minors': state => state.explore.minors,
      'careers': state => state.explore.careers,
      'industries': state => state.explore.industries,
      'careerResults': state => state.explore.careerResults,
      'programResults': state => state.explore.programResults,
      'selectedMajor': state => state.explore.selectedMajor,
      'selectedMinor': state => state.explore.selectedMinor,
      'selectedIndustry': state => state.explore.selectedIndustry,
      'selectedCareer': state => state.explore.selectedCareer,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'currentFacet': state => state.explore.currentFacet
    }),
    isClearlyNextPackageEnabled () {
      let clearlyNextFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CLEARLY_NEXT_FEATURE_ID]
      if (clearlyNextFeature && clearlyNextFeature.enabled) {
        return true
      }
      return false
    },
    isExplorePackageEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isExploreProgramsEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isExploreCareersEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_CAREERS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isExploreInsightsEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_INSIGHTS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreIntro.vue